import {PokerHeroPromo} from './paypal-buy-dialog.model';

export const PROMO_CODES: PokerHeroPromo[] = [
  {
    codes: ['HS', 'STORO08', '2PLUS2', 'PokerHero', 'rakecrush'],
    discount: 10,
  },
];
